import React, {Component} from 'react';
import {connect, dispatch} from 'react-redux';
import {bindActionCreators} from 'redux';
import Typekit from 'react-typekit';

import * as Actions from '../actions/index';

import MapFull from '../components/map-full';


class MapperCity extends Component {
    constructor(props) {
	    super(props);
	    this.state = {
		    mapView: true,
		    zoom: null,
		    center: null		    
		};
	}
    
    componentWillMount() {
		//need to get tag, lookup the id then fetch it's contents.
		let location_array = this.props.router.location.pathname.split("/");
		console.log(location_array);
		var location_array_length = location_array.length;
		console.log(location_array_length);
		this.props.actions.getTaxIdFromSlug('tags', location_array[location_array_length - 2]);
		console.log('tag id is: ');
		console.log(this.props.tags);
        //this.props.fetchTagPosts();
        
        switch (location_array[location_array_length - 2]) {
	        case 'west-chester':
	        	this.setState(state => ({
			      zoom: 14,
			      center:{lat:39.962811, lng:-75.598739}
			    }));
			    break;
			 case 'phoenixville':
	        	this.setState(state => ({
			      zoom: 14,
			      center:{lat:40.131098, lng:-75.517214}
			    }));
			    break;
			 case 'kennett-square':
	        	this.setState(state => ({
			      zoom: 14,
			      center:{lat:39.843518, lng:-75.710977}
			    }));
			    break;
        }
        
    }

    componentDidUpdate() {
        if (Array.isArray(this.props.tags) && this.props.tags.length) {
        	document.title = this.props.tags[0].name;
        }
    }
    

    render() {
        if (Array.isArray(this.props.tags) && this.props.tags.length) {
	        this.props.actions.fetchTagPosts('cc-posts', this.props.tags[0].id);
        }
        return (
            <section className="kiosk-wrapper">
	            <div className="kiosk-wrapper">
					<div className="map-wrapper">
		                <Typekit kitId="eab1tpm" />
		                <MapFull 
		                	zoom={this.state.zoom}
		                	center={this.state.center}
		                />
	                </div>
	            </div>
            </section>
        );

    }
}

function mapStateToProps(state) {
	return {
		tags: state.tags,
		selectedCat: state.selectedCat,
		router: state.router
	};
}


function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MapperCity)


// WEBPACK FOOTER //
// ./src/containers/mapper-city.js